import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;
  height: 100%;
  background-color: ${COLORS.white};
  margin-right: 1rem;
`

export const SelectedProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 0.5rem;
  overflow-y: auto;
`

export const NoMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  p {
    color: ${COLORS.darkGray};
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  span {
    color: ${COLORS.darkGray};
    font-size: 1rem;
  }
`

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 95%;
`
